import { forwardRef } from 'react';
import clsx from 'clsx';

export const Switch = forwardRef(function Switch({ className, checked, onCheckedChange, disabled, ...props }, ref) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      ref={ref}
      disabled={disabled}
      onClick={() => {
        if (disabled) return;
        onCheckedChange && onCheckedChange(!checked);
      }}
      className={clsx(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[color:var(--color-brand-teal)] disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-brand-teal' : 'bg-slate-300 dark:bg-slate-700',
        className,
      )}
      {...props}
    >
      <span
        className={clsx(
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-lg ring-0 transition-transform',
          checked ? 'translate-x-5' : 'translate-x-1',
        )}
      />
    </button>
  );
});

export default Switch;
